<template>
    <div>
        <component :is="landingPage" />
    </div>
</template>

<script>

import LineLogin from '@/components/Public/Line/LineLogin.vue'
import FastScan from '@/components/Public/Line/FastScan.vue'

export default {
  name: 'PublicIndexPage',
  components: {
    LineLogin,
    FastScan
  },
  data : function()  {
    return {
      landingPage: '',
    }
  },
  created: function() {
    let now_location = window.location.href
    do {

      if (now_location.indexOf('/line/login') !== -1){
        this.landingPage = LineLogin
        break;
      }

      if (now_location.indexOf('/line/fast_scan') !== -1) {
        this.landingPage = FastScan
        break;
      }

    }while(0)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
